import React from 'react';
import PropTypes from 'prop-types';
import {
  Segment,
  Image,
  Popup,
  Icon,
} from 'semantic-ui-react';
import numeral from 'numeral';
import _ from 'lodash';

const noMargin = {
  margin: '0',
};

const autoMargin = {
  margin: 'auto',
};

const InfluencerCardPreview = props => {
  const {
    name,
    thumbnail,
    primarySocialHandle,
    facebookCount,
    twitterCount,
    instagramCount,
    youtubeCount,
    tiktokCount,
    telegramFound,
    primarySocialHandleYoutube,
    youtubeChannelTitle,
    showTelegram,
    instagramLoading,
    brandLogo,
  } = props;


  const instagramComputed = _.isNumber(instagramCount);

  return (
    <Segment padded textAlign="center">
      <div className={!thumbnail && 'faded'} />
      { !instagramLoading && !thumbnail && !_.isNil(brandLogo) && <Image
        src={brandLogo.src}
        alt={brandLogo.alt}
        size="medium"
        style={autoMargin}
      />}
      { !instagramLoading && !thumbnail && _.isNil(brandLogo) && <Image
        src="/icons/grey-box.svg"
        alt="Thumbnail image"
        avatar
        size="tiny"
      />}
      { !instagramLoading && thumbnail && <Image
        src={thumbnail || '/icons/grey-box.svg'}
        alt="Thumbnail image"
        avatar
        size="tiny"
      />}
      { instagramLoading && <Icon name="circle notched" loading color="teal" size="huge" />}
      <div className="spacer small" />
      <h3>{name || 'Name'}</h3>
      <p className="light">
        {primarySocialHandleYoutube && youtubeChannelTitle}
        {!primarySocialHandleYoutube && primarySocialHandle}
        {!primarySocialHandleYoutube && !primarySocialHandle && '@handle'}
      </p>
      <div className="spacer small" />
      <div className="flex social-stripe">
        <div className={`instagram ${instagramComputed && 'active'}`} />
        <div className={`twitter ${twitterCount > 0 && 'active'}`} />
        <div className={`tiktok ${tiktokCount > 0 && 'active'}`} />
        <div className={`youtube ${youtubeCount > 0 && 'active'}`} />
        <div className={`facebook ${facebookCount > 0 && 'active'}`} />
        {showTelegram && <div className={`telegram ${telegramFound > 0 && 'active'}`} />}
      </div>
      <div className="spacer small" />
      <div className="flex">
        <div className={`equal align-center ${!instagramComputed && 'faded'}`}>
          <img src="/icons/instagram.svg" alt="Instagram" />
          {instagramComputed && instagramCount < 0 && <p>
            <Popup
              trigger={<Icon style={noMargin} name="clock" color="orange" />}
              content="The follower count will populate shortly"
            />
          </p>}
          {instagramComputed && instagramCount >= 0 && <p>
            {numeral(instagramCount).format('0a')}
          </p>}
          {!instagramComputed && <p>-</p>}
        </div>
        <div className={`equal align-center ${!twitterCount && 'faded'}`}>
          <img src="/icons/twitter.svg" alt="Twitter" />
          <p>{twitterCount ? numeral(twitterCount).format('0a') : '-'}</p>
        </div>
        <div className={`equal align-center ${!tiktokCount && 'faded'}`}>
          <img src="/icons/tiktok.svg" alt="Tiktok" height="28" />
          <p>{tiktokCount ? numeral(tiktokCount).format('0a') : '-'}</p>
        </div>
        <div className={`equal align-center ${!youtubeCount && 'faded'}`}>
          <img src="/icons/youtube.svg" alt="YouTube" />
          <p>{youtubeCount ? numeral(youtubeCount).format('0a') : '-'}</p>
        </div>
        <div className={`equal align-center ${!facebookCount && 'faded'}`}>
          <img src="/icons/facebook.svg" alt="Facebook" />
          <p>{facebookCount ? numeral(facebookCount).format('0a') : '-'}</p>
        </div>
        {showTelegram && <div className={`equal align-center ${telegramFound === 0 && 'faded'}`}>
          <img src="/icons/telegram.svg" alt="Telegram" height="28" />
          { telegramFound > 0 && <p><Icon name="check circle" color="green" /></p> }
          { (!telegramFound || telegramFound <= 0) && <p>-</p> }
        </div>}
      </div>
    </Segment>
  );
};

InfluencerCardPreview.propTypes = {
  name: PropTypes.string.isRequired,
  primarySocialHandle: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  youtubeCount: PropTypes.number.isRequired,
  twitterCount: PropTypes.number.isRequired,
  instagramCount: PropTypes.number.isRequired,
  tiktokCount: PropTypes.number.isRequired,
  facebookCount: PropTypes.number.isRequired,
  telegramFound: PropTypes.number.isRequired,
  primarySocialHandleYoutube: PropTypes.bool.isRequired,
  showTelegram: PropTypes.bool,
  instagramLoading: PropTypes.bool,
  brandLogo: PropTypes.object,
};


InfluencerCardPreview.defaultProps = {
  showTelegram: true,
  instagramLoading: false,
  brandLogo: null,
};

export default InfluencerCardPreview;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-card-preview/index.js
 **/